import { Environment } from '@starjack/entities/environment';

export type DashboardEnvSlug =
    'b2b' | 'webshop' | 'starjack-portal' | 'hospitality';

export const DASHBOARD_ENV_SLUGS: DashboardEnvSlug[] = [
    'b2b',
    'webshop',
    'starjack-portal',
    'hospitality',
];

const DEFAULT_APP_NAME = 'Starjack Admin';

export type DashboardEnvConfig = {
    environment: Environment;
    title: string;
};

const slugToEnvironment: Record<DashboardEnvSlug, Environment> = {
    b2b: Environment.B2B,
    webshop: Environment.INTEGRATION,
    'starjack-portal': Environment.PORTAL,
    hospitality: Environment.HOSPITALITY,
};

/**
 * Returns the environment and page title for a given dashboard env slug.
 * Used by admin (and other apps) to drive the shared env-specific dashboard page.
 */
export function getDashboardEnvConfig(
    slug: DashboardEnvSlug,
    options?: { appName?: string }
): DashboardEnvConfig {
    const appName = options?.appName ?? DEFAULT_APP_NAME;
    const env = slugToEnvironment[slug];
    const envLabel =
        slug === 'b2b'
            ? 'B2B'
            : slug === 'webshop'
              ? 'Webshop'
              : slug === 'starjack-portal'
                ? 'Portal'
                : 'Hospitality';
    return {
        environment: env,
        title: `Dashboard - ${envLabel} | ${appName}`,
    };
}
